import { makeStyles } from "@material-ui/core";

//Util functions
function getCurrentStepIndex(state) {
  const steps = state.steps;
  const activeStepId = state.activeStep;
  const currStepObject = steps.find((row) => row.id === activeStepId);
  const currStepIndex = steps.indexOf(currStepObject);
  return currStepIndex;
}

// Defining static variables/functions
function defaultFormValidator(state, payload) {
  return { flag: true, message: "" };
}

// Making styles
//1- Stepper styling
const makeSigviewStepperStyles = (themeColors) => {
  const useStyles = makeStyles(() => ({
    stepperRootContainer: {
      // height: "70px",
      height: "50px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      // paddingBottom: "20px",
      marginBottom: "15px",
      boxSizing: "content-box !important",
    },
    stepperRoot: {
      "& *": {
        lineHeight: "1 !important",
        fontFamily: "Fira Sans !important",
      },
      "& .MuiStepButton-root": {
        margin: "0 !important",
        padding: "0 !important",
      },
      padding: "0 !important",
      width: "100%",
      // backgroundColor: "#f8f9fd !important",
    },

    stepButtonBase: {
      "& .MuiSvgIcon-root": {
        height: "23px !important",
        width: "23px !important",
        border: "4px solid transparent",
        borderRadius: "999em",
        "& circle": {
          // color: `${themeColors["secondaryColorLighter"]} !important`,
          // color: `${themeColors["secondaryColorLight"]} !important`,
          color: "rgba(217, 222, 226, 1)",
        },
        "& text":{
          fontSize: "14px",
          fill: `${themeColors["secondaryColor"]}`,
        },
      },
      "& .MuiStepLabel-label": { fontSize: "0.75rem !important" },
      "& .MuiStepLabel-alternativeLabel": {
        color: `${themeColors["secondaryColorLight"]} !important`,
      },
      "& .MuiStepLabel-label.MuiStepLabel-alternativeLabel": {
        marginTop: "3px !important",
      },
    },

    stepConnectorBase: {
      "& .MuiStepConnector-root": {
        top: "20px !important",
        left: "calc(-50% + 40px) !important",
        right: "calc(50% + 40px) !important",
        position: "absolute !important",
        "& .MuiStepConnector-line": {
          display: "block",
          borderColor: "#8C8A88",
          borderRadius: "999em",
        },
      },
      "& .MuiStepConnector-lineHorizontal": {
        borderTopStyle: "solid !important",
        borderTopWidth: "3px !important",
      },
    },
    stepConnectorVisited: {
      "& .MuiStepConnector-root": {
        "& .MuiStepConnector-line": {
          borderColor: themeColors["primaryColor"],
        },
      },
    },

    stepConnectorActive: {
      "& .MuiStepConnector-root": {
        "& .MuiStepConnector-line": {
          borderColor: themeColors["primaryColor"],
        },
      },
    },

    stepButtonVisited: {
      "& .MuiStepIcon-root": {
        "& circle": {
          borderColor: `${themeColors["primaryColor"]} !important`,
        },
        border: `4px solid ${themeColors["primaryColor"]}1A`,
        borderRadius: "999em",
        "&.MuiStepIcon-completed": {
          color: `${themeColors["primaryColor"]} !important`,
        }
      },
      "& .MuiStepLabel-alternativeLabel": {
        borderColor: `${themeColors["primaryColor"]} !important`,
        "&.MuiStepLabel-completed": {
          color: `${themeColors["primaryColor"]} !important`,
        },
      },
    },
    stepButtonActive: {
      "& .MuiStepIcon-active": {
        "& circle": {
          color: `${themeColors["primaryColor"]} !important`,
        },
        "& text":{
          fontSize: "14px",
          fill: "white",
        },
        border: `4px solid ${themeColors["primaryColor"]}1A`,
        borderRadius: "999em",
      },
      "& .MuiStepLabel-alternativeLabel": {
        "&.MuiStepLabel-active": {
          color: `${themeColors["primaryColor"]} !important`,
        },
      },
    },
  }));
  return useStyles;
};
//2- Main content styling
const makeSigviewStepperMainContainerStyles = (themeColors) => {
  const useStyles = makeStyles(() => ({
    mainContainer: { height: "100%", padding: "0px" },
    mainContentRootContainer: {
      height: "calc(100% - 105px)",
      display: "flex",
      flexDirection: "column",
      // alignItems: "center",
      // justifyContent: "space-between",
      overflow: "auto",
    },
  }));
  return useStyles;
};
//3- Bottom container styling
const makeSigviewStepperBottomStyles = (themeColors) => {
  const useStyles = makeStyles(() => ({
    bottomRootContainer: {
      // height: "30px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "0px 25px",
      marginBlock: "10px",
    },
    bottomRightContainer: {
      display: "flex",
      "&>:not(:last-child)": {
        marginRight: "15px !important",
        position: "relative",

        "&::after":{
          content: '""',
          position: "absolute",
          right: "-8px",
          top: "20%",
          width: "1px",
          height: "65%",
          backgroundColor: themeColors["secondaryColorLighter"],
        }
      },
    },
  }));
  return useStyles;
};

const stepperStyles = {
  makeSigviewStepperStyles,
  makeSigviewStepperMainContainerStyles,
  makeSigviewStepperBottomStyles,
};

export { getCurrentStepIndex, defaultFormValidator, stepperStyles };
